module.exports = __webpack_public_path__ + "static/media/osborneWhite@3x.4420c3ae.png";